import 'react';
import { VariantSwitcher } from '../../../VariantSwitcher/VariantSwitcher.js';
import { ProductBlockIncludesLensesLink } from './components/ProductBlockIncludesLensesLink/ProductBlockIncludesLensesLink.js';
import { ProductBlockFooter as ProductBlockFooter$1 } from './ProductBlockFooter.js';

const ProductBlockFooter = Object.assign(ProductBlockFooter$1, {
    Variants: VariantSwitcher,
    IncludesLensesLink: ProductBlockIncludesLensesLink
});

export { ProductBlockFooter };
//# sourceMappingURL=index.js.map
